module.exports = __webpack_public_path__ + "img/phones.778b970.jpg";